import { render, staticRenderFns } from "./TrafficMessageContainer.vue?vue&type=template&id=454c6bb3"
import script from "./TrafficMessageContainer.vue?vue&type=script&lang=js"
export * from "./TrafficMessageContainer.vue?vue&type=script&lang=js"
import style0 from "./TrafficMessageContainer.vue?vue&type=style&index=0&id=454c6bb3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports